import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
import { LoggedOutReturnType } from '../../../redux/loggedout';
import { formatPrice } from '../../../DeviationViews/TierProductCardDumb/utils';
import { DeviationResourceType } from '../../../types/deviation';
var SubscribeVariant = function (_a) {
    var _b, _c;
    var tier = _a.tier, _d = _a.tier.tier, _e = _d === void 0 ? {} : _d, dollarPrice = _e.dollarPrice, _f = _a.withPrice, withPrice = _f === void 0 ? false : _f, _g = _a.size, size = _g === void 0 ? 'medium' : _g, className = _a.className, href = _a.href, onSubscribe = _a.onSubscribe;
    var t = useTranslation().t;
    var restrictToLoggedIn = useRestrictToLoggedIn().restrictToLoggedIn;
    var subscribe = restrictToLoggedIn(ReferralType.MEMBER_SUBSCRIBE, onSubscribe, ((_b = tier.tier) === null || _b === void 0 ? void 0 : _b.subproductId)
        ? Url.checkoutLink((_c = tier.tier) === null || _c === void 0 ? void 0 : _c.subproductId)
        : undefined, LoggedOutReturnType.JOIN_ONLY);
    var showPrice = withPrice && dollarPrice;
    return (React.createElement(BrandedButton, { isFakeButton: true, className: className, size: size, variant: "brand-green", href: href, onClick: function (e) {
            if (!onSubscribe) {
                return;
            }
            subscribe(tier);
            e.stopPropagation();
            e.preventDefault();
        }, biData: {
            evid: BiEventType.TIER_SUBSCRIBE,
            typeid: DeviationResourceType.TIER,
            itemid: tier.deviationId,
        } }, showPrice
        ? t('deviation.tier.subscribeWithPrice', {
            dollarPrice: formatPrice(dollarPrice),
        })
        : t('deviation.tier.subscribe')));
};
SubscribeVariant.displayName = 'SubscribeVariant';
export default SubscribeVariant;
//# sourceMappingURL=Subscribe.js.map